import styled from "styled-components";
import {BackTableFilter, PHP_TYPE_MAP} from "../../../features/schemaManageSlice";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import hljs from "highlight.js/lib/core";
import React, {useState} from "react";
import {getReadableTextColor} from "../../filters/FilterMultiMapValue";
import {FontAwesomeTypeIcon} from "../../misc/TypeIcon";
import {headerTypesIcons, schemas} from "../../../config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faEdit, faQuestion, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FIELD_TYPE_INFO, SqlOperationInfo} from "../../../Types";
import EditField from "./edit/EditField";
import EditFilter from "./edit/EditFilter";

interface BackTableFilterPropsI {
    tableName: string,
    filter: BackTableFilter,
    filterKey: string,
    index: number,
    proj: string
}

type FieldItemTypeU = "static" | "ethereal" | "other";

type FilterItemViewPropsI = {
    filter: BackTableFilter,
    filterKey: string,
    index: number,
    type: FieldItemTypeU,
    editable?: boolean,
    tableName: string,
    proj: string
};


interface BackTableFilterTablePropsI {
    tableName: string,
    filters: Record<string, BackTableFilter>,
}

export default function BackTableFilterViewTable({
                                                     tableName,
                                                     filters,
                                                 }: BackTableFilterTablePropsI) {

    const project = useAppSelector(state => state.project.name);


    return <Container>
        <table>
            <thead>
            <tr>
                <th></th>
                <th>Ключ</th>
                <th>PHP тип</th>
                <th>Операції</th>
                <th>Аліас</th>
                <th>Зовнішній</th>
                <th>На фронті</th>
                <th>#</th>
            </tr>
            </thead>
            <tbody>
            {Object.entries(filters).map(([key, filter], i) =>
                <BackTableFilterView key={key} index={i} proj={project} tableName={tableName} filterKey={key}
                                     filter={filter}/>)}
            </tbody>
        </table>

    </Container>
}

function BackTableFilterView({
                                 tableName,
                                 filterKey,
                                 filter,
                                 index,
                                 proj
                             }: BackTableFilterPropsI) {

    const staticTable = useAppSelector(state => state.schemaManage.back.staticTables[tableName]);
    const staticFilter = staticTable !== null && staticTable.filtersList[filterKey]
    const etherealTable = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const etherealFilter = etherealTable !== null && etherealTable.filtersList[filterKey]
    const mode = useAppSelector(state => state.schemaManage.back.mode);

    const dispatch = useAppDispatch();


    return <>
        {mode === "edit" && staticFilter &&
            <FilterItemView proj={proj} tableName={tableName} type={"static"} filter={staticFilter}
                            filterKey={filterKey}
                            index={index}/>}
        {mode === "edit" && etherealFilter &&
            <FilterItemView proj={proj} tableName={tableName} type={"ethereal"} editable filter={etherealFilter}
                            filterKey={filterKey} index={index}/>}
        {mode === "view" &&
            <FilterItemView proj={proj} tableName={tableName} type={"other"} filter={filter} filterKey={filterKey}
                            index={index}/>}
    </>
}

function FilterItemView({
                            filter,
                            index,
                            filterKey,
                            type,
                            editable = false,
                            tableName,
                            proj
                        }: FilterItemViewPropsI) {

    const filterSchema = schemas[proj].filterSchemas[tableName]?.[filterKey];

    const [isEditing, setIsEditing] = useState(false)
    const closeEditing = () => setIsEditing(false);

    return <>
        <tr className={"title"}>
            <td className={"icon"}>
                {filterSchema && <FontAwesomeTypeIcon className={'fa-color-text'} type={filterSchema.type}/>}
                {!filterSchema && <FontAwesomeIcon className={'fa-color-text'} icon={faQuestion}/>}
            </td>
            <td className={'key'}>
                <div className="cont">
                    <span>{filterKey}</span>
                    {editable && <button className={'edit-backtable-field btn-cmn'} onClick={() => setIsEditing(true)}>
                        <FontAwesomeIcon size={"lg"} icon={faEdit} className={'fa-secondary-color-text'}/>
                    </button>}
                </div>
                {isEditing &&
                    <EditFilter closeEditing={closeEditing} filter={filter} filterKey={filterKey}/>}
            </td>
            <td className="content">
                <span className={"php-type"}
                      style={{
                          background: PHP_TYPE_MAP[filter.type].color,
                          color: getReadableTextColor(PHP_TYPE_MAP[filter.type].color)
                      }}>{PHP_TYPE_MAP[filter.type].desc}</span>
            </td>
            <td className="sql-ops">
                <div className="f-ops">
                    {filter.operationsList.map((o, i) => <div key={i} className="op">
                        {SqlOperationInfo[o].sql}
                    </div>)}
                </div>
            </td>
            <td className="present">
                <FontAwesomeIcon size={"lg"}
                                 className={filter.appendAlias !== false ? 'fa-color' : 'fa-yellow'}
                                 icon={filter.appendAlias !== false ? faCheck : faXmark}/>
            </td>
            <td className="present">
                <FontAwesomeIcon size={"lg"}
                                 className={filter.outer ? 'fa-color' : 'fa-yellow'}
                                 icon={filter.outer ? faCheck : faXmark}/>

            </td>
            <td className="present">
                <FontAwesomeIcon size={"lg"}
                                 className={filterSchema ? 'fa-color' : 'fa-yellow'}
                                 icon={filterSchema ? faCheck : faXmark}/>

            </td>
            <td className={"index"}>{type === "static" && <i>STATIC |&nbsp;</i>}{index + 1}</td>
        </tr>
    </>;
}

const Container = styled.div`
    //display: flex;
    //flex-direction: column;
    //gap: .5rem;
    width: 100%;
    //max-width: 100%;
    padding: .4rem;
    border-radius: .2rem;
    background-color: var(--table-header-bg-color);
    //border-collapse: separate;
    overflow-x: auto;

    .php-type {
        padding: .2rem .4rem;
        border-radius: .2rem;
        width: 100%;
        white-space: nowrap;
        display: inline-block;
    }

    table {
        table-layout: auto;
        //max-width: 100%;
        width: 100%;
        //overflow-x: auto;
        //border: 1px solid var(--table-border-color);

        th, td {
            vertical-align: middle;
            padding: .4rem .2rem;
            line-height: 1.2;
            border-bottom: 2px solid var(--table-border-color);
            border-right: 2px solid var(--table-border-color);
            border-left: 2px solid var(--table-border-color);
            border-top: 2px solid var(--table-border-color);

        }


        //tr:not(last-child) {
        //    td {
        //        border-bottom: 2px solid red;
        //
        //    }
        //}

        th {
            text-align: center;
            white-space: nowrap;
        }
    }

    tbody {

        max-width: 100%;
        //overflow-x: scroll;
        overflow-x: auto;

        & > tr {
            max-width: 100%;
            width: 100%;
            overflow-x: auto;
        }

        td {

            //overflow-x: auto;

        }


    }

    .present {
        text-align: center;
        width: 1%;
    }

    .content {
        width: 1%;
    }

    .title {

        line-height: 1;

        .icon {
            //width: 1.25rem;
            //display: flex;
            //align-items: center;
            //justify-content: center;
            width: 1%;
            text-align: center;
        }

        .key {
            width: 1%;
            text-align: left;
            padding-right: .4rem;
            padding-left: .4rem;

            .cont {
                display: inline-flex;
                gap: .5rem;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                & button {
                    padding: .2rem;
                }
            }
        }


        .front-type {
            padding: .2rem .4rem;
            border-radius: .2rem;
            //width: fit-content;
            width: 100%;
            white-space: nowrap;
            display: inline-block;
            //height: 3rem;
            //width: 100%;
        }

        .missing {
            //background-color: #62615c;
            //color: yellow;
            //padding: .2rem .4rem;
            //border-radius: .2rem;
        }
    }

    .index {
        min-width: 30px;
        width: 1%;
        text-align: center;
        white-space: nowrap;
    }

    .sql-ops {
        width: 100%;
    }

    .f-ops {
        display: flex;
        gap: .5rem;
        line-height: 1;

        .op {
            background-color: #001973;
            color: #dadff4;
            font-weight: bold;
            padding: .2rem .4rem;
            border-radius: .2rem;
            white-space: nowrap;
        }
    }


`;
